import validate from 'validate.js';

const constraints = {
  nombre: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
};

export const validaSede = motivo => (
    (motivo ? validate(motivo, constraints) : {}) || {}
);